// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"f53ace45","329":"9dcc3ccc","683":"e3dc896e","899":"058bc040"}[chunkId] + ".chunk.css";
};